var map = {
	"./phone-screen-cn.png": "9781",
	"./phone-screen-de.png": "5c40",
	"./phone-screen-en.png": "6626",
	"./phone-screen-es.png": "0ffd",
	"./phone-screen-fr.png": "2070",
	"./phone-screen-id.png": "5232",
	"./phone-screen-it.png": "df66",
	"./phone-screen-jp.png": "0d5a",
	"./phone-screen-kr.png": "a432",
	"./phone-screen-pt.png": "9cd6",
	"./phone-screen-ru.png": "c3e1",
	"./phone-screen-thai.png": "8807",
	"./phone-screen-tr.png": "3bba",
	"./phone-screen-vt.png": "6e37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53f3";